import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, CanActivate, Router } from "@angular/router";
import { quickWebLogger } from "@quickweb/logger";
import { DeviceInfoNativeService } from "../comunicator-native/device-info-native/device-info-native";
import { JourneyService } from "../journey/journey.service";

@Injectable()
export class RouterGuard implements CanActivate {
  constructor(
    protected router: Router,
    private journeyService: JourneyService,
    private deviceInfoNativeService: DeviceInfoNativeService
  ) {}

  async canActivate(routeAc: ActivatedRouteSnapshot) {
    return await this.validateRoute(routeAc);
  }

  async validateRoute(routeAc: ActivatedRouteSnapshot): Promise<boolean> {
    const journey = routeAc.queryParams?.journey;
    const typeData = routeAc.queryParams?.typeData;

    const currentJourney = journey ?? this.journeyService.journey;
    
    if (currentJourney) {
      quickWebLogger.rum.startView({
        pageName: `${currentJourney}/${location.hash}`,
      });
    }

    if (journey) {
      // Incluindo a chamada da interface para a toggle de exibição da tela de custódia e rlp
      if (journey === "basic-v2") {
        this.deviceInfoNativeService.getItemCommunicator();
      }
      if (journey === "update-registration") {
        localStorage.setItem("getToggle", "false");
      }
      // Incluindo param para recebimento da primeira tela, nativo
      if (
        routeAc.queryParams?.cameFromLogin &&
        routeAc.queryParams?.cameFromLogin === "true"
      ) {
        localStorage.setItem("cameFromLogin", routeAc.queryParams?.cameFromLogin);
      }
      this.journeyService
        .setTrack(journey, typeData)
        .then(() => {
          this.router.navigate(this.journeyService.selectedTrack.track[0].path);
          return Promise.resolve(false);
        })
        .catch(() => {
          this.router.navigate(this.journeyService.selectedTrack.track[0].path);
        });
    } else {
      return Promise.resolve(true);
    }
  }
}
